"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var react_number_format_1 = require("react-number-format");
var themeInput = require("./theme.scss");
var Input = /** @class */ (function (_super) {
    tslib_1.__extends(Input, _super);
    function Input(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.setExposedRef = function (el) {
            var exposedRef = _this.props.exposedRef;
            exposedRef && exposedRef(el);
        };
        _this.onChange = function (e) {
            var _a = _this.props, onChange = _a.onChange, min = _a.min;
            var originalValue = e.target.value;
            if (typeof min === "number" && min > -1) {
                e.target.value = Number(e.target.value.replace(/[\-,]/g, ""));
            }
            else {
                e.target.value = Number(e.target.value.replace(/\,/g, ""));
            }
            e.target.type = "number";
            onChange(e);
            e.target.type = "text";
            e.target.value = originalValue;
        };
        return _this;
    }
    Input.prototype.render = function () {
        var _a;
        var _b = this.props, className = _b.className, theme = _b.theme, value = _b.value, center = _b.center, defaultValue = _b.defaultValue, focus = _b.focus, multiline = _b.multiline, rows = _b.rows, disabled = _b.disabled, required = _b.required, readOnly = _b.readOnly, fill = _b.fill, invalid = _b.invalid, exposedRef = _b.exposedRef, thousandSeparator = _b.thousandSeparator, permanentPlaceholder = _b.permanentPlaceholder, others = tslib_1.__rest(_b, ["className", "theme", "value", "center", "defaultValue", "focus", "multiline", "rows", "disabled", "required", "readOnly", "fill", "invalid", "exposedRef", "thousandSeparator", "permanentPlaceholder"]);
        var classes = classnames_1.default(theme.input, className, (_a = {},
            _a[theme.focus] = focus,
            _a[theme.invalid] = invalid,
            _a[theme.disabled] = disabled,
            _a[theme.fill] = fill,
            _a[theme.center] = center,
            _a));
        var inputProps = tslib_1.__assign({}, others, { className: classes, disabled: disabled,
            required: required,
            readOnly: readOnly,
            value: value,
            defaultValue: defaultValue });
        if (exposedRef) {
            inputProps.ref = this.setExposedRef;
        }
        if (multiline) {
            inputProps.rows = rows;
        }
        if (thousandSeparator) {
            return React.createElement(react_number_format_1.default, tslib_1.__assign({ getInputRef: exposedRef, thousandSeparator: true }, inputProps, { onChange: this.onChange, type: "text" }));
        }
        if (permanentPlaceholder) {
            var input = React.createElement(multiline ? "textarea" : "input", inputProps);
            return (React.createElement("div", { className: themeInput.permanentPlaceholder },
                input,
                React.createElement("span", { className: themeInput.text }, permanentPlaceholder)));
        }
        return React.createElement(multiline ? "textarea" : "input", inputProps);
    };
    Input.defaultProps = {
        type: "text",
        multiline: false,
        rows: 1,
        disabled: false,
        required: false,
        readOnly: false,
        invalid: false,
        focus: false,
        fill: false,
        autoComplete: "off"
    };
    return Input;
}(React.Component));
exports.default = Input;
